<template>
  <g>
    <g transform="scale(1.2)">
        <text transform="matrix(1 0 0 1 185 280)" class="name">
            트랜지스터{{ number }}</text>
        <g class="pin">
            <line
                fill="#BCBEC0"
                stroke="#BCBEC0"
                stroke-width="4"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="214.333"
                y1="306.833"
                x2="214.333"
                y2="357.833"
            />
            <rect
                :id="`${pincode}BS`"
                @click="onClick(`${pincode}BS`)"
                class="pin-cover terminal snap"
                x="210"
                y="355"
                width="10"
                height="10"
            />
            <text transform="matrix(1 0 0 1 210 385)" class="pin-name">B</text>
        </g>
        <g class="pin" style="transform: translate(-3px,0)">
            <path
                fill="none"
                stroke="#BCBEC0"
                stroke-width="4"
                stroke-linecap="round"
                stroke-miterlimit="10"
                d="M203.805,357.477v-27.762
            c0-3.118,0.553-6.063,1.229-6.544c0.676-0.481,1.23-0.866,1.23-0.856c0.001,0.01,0.396-0.375,0.877-0.856s0.875-3.426,0.875-6.544
            v-7.331"
            />
            <rect
                :id="`${pincode}CL`"
                @click="onClick(`${pincode}CL`)"
                class="pin-cover terminal snap"
                x="200"
                y="355"
                width="10"
                height="10"
            />
            <text transform="matrix(1 0 0 1 200 385)" class="pin-name">C</text>
        </g>
        <g class="pin" style="transform: translate(3px,0)">
            <path
                fill="none"
                stroke="#BCBEC0"
                stroke-width="4"
                stroke-linecap="round"
                stroke-miterlimit="10"
                d="M224.862,357.477v-27.762
            c0-3.118-0.553-6.063-1.229-6.544c-0.676-0.481-1.23-0.866-1.23-0.856c-0.001,0.01-0.396-0.375-0.877-0.856
            s-0.875-3.426-0.875-6.544v-7.331"
            />
            <rect
                :id="`${pincode}EM`"
                @click="onClick(`${pincode}EM`)"
                class="pin-cover terminal snap"
                x="220"
                y="355"
                width="10"
                height="10"
            />
            <text transform="matrix(1 0 0 1 220 385)" class="pin-name">E</text>
        </g>
        <g>
            <path
                fill="#414042"
                d="M225.833,310.999c0,1.56-1.275,2.835-2.834,2.835h-17.331c-1.559,0-2.834-1.275-2.834-2.835v-19.33
            c0-1.56,1.275-2.835,2.834-2.835h17.331c1.559,0,2.834,1.275,2.834,2.835V310.999z"
            />
        </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Transistor',
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover {
    display: block;
    stroke: none;
    fill: none;
}
.pin-name {
    display: none;
    font-size: 15px;
}

.pin:hover {
    cursor: pointer;
    .pin-cover {
        stroke-width: 3px;
        stroke: black;
        fill: #ff6f61;
    }
    .pin-name {
        display: block;
    }
}
.name {
    font-size: 12px;
}
.selected{
    path, line{
        stroke: #ff6f61;
    }
}
</style>
